import i18n from '@signavio/i18n';
import { LegacyHint } from '@signavio/ui';
import { jsx as _jsx } from "react/jsx-runtime";
function createLoadingMessage(messageCreator) {
  return function LoadingMessage(props) {
    const {
      error,
      loading
    } = messageCreator(props);
    if (props.error) {
      return /*#__PURE__*/_jsx(LegacyHint, {
        danger: true,
        view: true,
        children: error || props.error
      });
    }
    if (props.pastDelay) {
      return /*#__PURE__*/_jsx(LegacyHint, {
        loading: true,
        view: true,
        children: loading || i18n('Preparing this view...')
      });
    }
    return null;
  };
}
export default createLoadingMessage;